import { useLocation } from 'react-router';

import ClearFix from './clear-fix';
import { shorttrackPath } from './constants/links';

import './header.scss';

export default function Header() {
  const { pathname } = useLocation();
  const facebookUrl = pathname.startsWith(shorttrackPath)
    ? 'https://www.facebook.com/ShortTrack2019'
    : 'https://www.facebook.com/FigureSkatingSofia';

  return (
    <div className="agileheader">
      <div className="container">
        <div className="agile-hdleft nav navbar-nav navbar-left">
          <p>
            <i className="fa fa-phone" aria-hidden="true"></i>+359 2 988 75 71
          </p>
        </div>
        <div className="agileits-hdright nav navbar-nav navbar-right">
          <div className="social-icon">
            <a href={facebookUrl} className="social-button facebook" target="_blank" rel="noreferrer">
              <i className="fa fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/bulgarianskatingfederation"
              className="social-button google"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-instagram"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UCQm3qTqSVlHzxkUADN_q_cA"
              className="social-button youtube"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-youtube"></i>
            </a>
          </div>
        </div>
        <ClearFix />
      </div>
    </div>
  );
}
